import React from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

// Icons
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import ApartmentIcon from "@mui/icons-material/Apartment";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import GroupsIcon from "@mui/icons-material/Groups";

const ProjectLayoutPage = ({ data }) => {
  return (
    <Box sx={{ width: "100%", mb: 0, mt: 2 }}>
      {/* HERO SECTION */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          height: { md: "520px" },
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        {/* LEFT: IMAGE */}
        <Box sx={{ flex: 6, position: "relative" }}>
          <TransformWrapper
            initialScale={1}
            minScale={0.7}
            maxScale={4}
            centerOnInit
            wheel={{ disabled: true }}
            doubleClick={{ disabled: true }}
            zoomAnimation={{ size: 0.3 }}
          >
            {({ zoomIn, zoomOut, resetTransform }) => (
              <>
                {/* ZOOM CONTROLS */}
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    zIndex: 10,
                    backgroundColor: "#fff",
                    borderRadius: 1,
                    boxShadow: 3,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Tooltip title="Zoom In">
                    <IconButton onClick={() => zoomIn()}>
                      <ZoomInIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Zoom Out">
                    <IconButton onClick={() => zoomOut()}>
                      <ZoomOutIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Reset">
                    <IconButton onClick={() => resetTransform()}>
                      <RestartAltIcon />
                    </IconButton>
                  </Tooltip>
                </Box>

                {/* IMAGE */}
                <TransformComponent
                  wrapperStyle={{ width: "100%", height: "100%" }}
                  contentStyle={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={data.layout_url}
                    alt="Project Layout"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      width: "auto",
                      height: "auto",
                      objectFit: "contain",
                      userSelect: "none",
                      pointerEvents: "none",
                    }}
                  />
                </TransformComponent>
              </>
            )}
          </TransformWrapper>
        </Box>

        {/* RIGHT: INFO PANEL */}
        <Box
          sx={{
            flex: 4,
            backgroundColor: "#ffff",
            color: "black",
            p: 3,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
              {data?.project_name || data?.name}
            </Typography>

            <Box sx={{ display: "flex", alignItems: "flex-start", mb: 5 }}>

              {/* Column 1 - Icon */}
              <LocationOnIcon sx={{ mr: 2, fontSize: 40, mt: 0.5, opacity: 0.8 , }} />

              {/* Column 2 - Address + City */}
              <Box>
                <Typography sx={{ opacity: 0.9, fontWeight: 500 }}>
                  {data?.address}
                </Typography>
                <Typography sx={{ opacity: 0.7 }}>
                  {data?.city}
                </Typography>
              </Box>

            </Box>

            {data?.number_of_plots !== null && data?.number_of_plots !== undefined && (
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <GroupsIcon sx={{ mr: 1, fontSize: 20, opacity: 0.8 }} />
                <Typography>
                  <strong>Total Plots:</strong> {data.number_of_plots}
                </Typography>
              </Box>
            )}

            {data?.available_plots !== null && data?.available_plots !== undefined && (
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <GroupsIcon sx={{ mr: 1, fontSize: 20, opacity: 0.8 }} />
                <Typography>
                  <strong>Available Plots:</strong> {data.available_plots}
                </Typography>
              </Box>
            )}


            {/* <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <BusinessIcon sx={{ mr: 1, fontSize: 20, opacity: 0.8 }} />
              <Typography>
                <strong>Builder:</strong> {data.builder}
              </Typography>
            </Box> */}

            {/* <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <MeetingRoomIcon sx={{ mr: 1, fontSize: 20, opacity: 0.8 }} />
              <Typography>
                <strong>Unit Sizes:</strong> {data.unit_sizes}
              </Typography>
            </Box> */}

            {data?.totalArea !== null && data?.totalArea !== undefined && data?.totalArea !== "" && (
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <CropSquareIcon sx={{ mr: 1, fontSize: 20, opacity: 0.8 }} />
                <Typography>
                  <strong>Total Land Area:</strong> {data.totalArea}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectLayoutPage;